module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAAAXNSR0IArs4c6QAAAOdJREFUKBWNk88KAXEUhfEGsyOSNE2SrDyOB1BKUoqivIKyUEp5GSvWkiT5E/EKjO/WTN3kmrl1+p2Z853u/BaTSESM7/seWqI1Sv/FAVx0RuHUzQJEEZ1CMvDOzwJhAR0VLFtcC84THhR8xXsWnCPcK/iGL1lwlnCn4Du+bMEZwq2CH/iKBTuEGwU/8dWfsLwkbCn4ha+ZMEEKraQXQPLcpiSnPQAN9EbhLDCRpWZIB+ecM2mvIQHQ95HeLE6pI6SaKT5yU1cVxE7+fpqEQL2v0jhOafBVGsYpjVTpElkQgILcSf6J/gcd5nxaGG7ltgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-open.png
// module id = 365
// module chunks = 0 1 2